import { Chip} from '@mui/material'
import Tooltip,{tooltipClasses} from '@mui/material/Tooltip'
import React from 'react'
import { alpha, styled } from '@mui/material/styles';

const StyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: '6px',
  py:'2px',
  px:1
}));

const NoMaxWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
  },
});

export const TopicChip = ({ tooltip = false, tooltipText = '', sx = {}, size = 'small', ...props }) => {
  return (
    <NoMaxWidthTooltip  title={tooltip ? tooltipText : ''} disableInteractive arrow>
      <StyledChip size={size} sx={{ ...sx }} {...props} />
    </NoMaxWidthTooltip>
  )
}

